let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("adfUx"), load("eVnxm")]).then(() => parcelRequire('5MSS3'));